//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    data: function data() {
        return {
            loading: true,
            lateFee: {
                number_of_start_day: 4,
                number_of_days_to_run: 15
            }
        };
    },


    methods: {
        load: function load() {
            this.$children[0].$data.showModal = true;
            Object.assign(this.$data, this.$options.data());
        },
        update: function update() {
            var _this = this;

            axios.post('/prototype/late-fees/update-global', this.lateFee).then(function () {
                _this.$snotify.success('All late fee settings were updated');
                _this.load();
            });
        },
        close: function close() {
            Event.$emit('close-full-modal');
        }
    },

    created: function created() {
        Event.$on('global-settings-late-fees', this.load);
        Event.$on('add-global-late-fee', this.addNewFee);
        Event.$on('edit-global-late-fee', this.editLateFee);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('global-settings-late-fees');
        Event.$off('add-global-late-fee');
        Event.$off('edit-global-late-fee');
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/settings/GlobalLateFeeSettings.vue
// module id = +BT8
// module chunks = 0 1